/* eslint-disable */
export default {
  'routes': [
    {
      'resolve': () => import('./../../routes/404/index.js'),
      'rotation': 'routes',
      'path': '/404/',
      'dynamic': false,
      'title': '',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/academic-term/index.js'),
      'rotation': 'routes',
      'path': '/academic-term/',
      'dynamic': false,
      'title': 'Academic Term::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/500/index.js'),
      'rotation': 'routes',
      'path': '/500/',
      'dynamic': false,
      'title': '',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/503/index.js'),
      'rotation': 'routes',
      'path': '/503/',
      'dynamic': false,
      'title': 'Down For Maintenance',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/account-management/index.js'),
      'rotation': 'routes',
      'path': '/account-management/',
      'dynamic': false,
      'title': 'Account Management',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/assign-skills/index.js'),
      'rotation': 'routes',
      'path': '/assign-skills/',
      'dynamic': false,
      'title': 'Assign Skills::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/cohorts/index.js'),
      'rotation': 'routes',
      'path': '/cohorts/',
      'dynamic': false,
      'title': 'Cohort::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/dashboard/index.js'),
      'rotation': 'routes',
      'path': '/dashboard/',
      'dynamic': false,
      'title': 'Dashboard::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/getting-started/index.js'),
      'rotation': 'routes',
      'path': '/getting-started/',
      'dynamic': false,
      'title': 'Onboarding::Getting Started',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/home/index.js'),
      'rotation': 'routes',
      'path': '/',
      'dynamic': false,
      'title': 'Home::AofL Management System',
      'meta': {
        'hideLeftPanel': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/logout/index.js'),
      'rotation': 'routes',
      'path': '/logout/',
      'dynamic': false,
      'title': 'Logout::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/landing/index.js'),
      'rotation': 'routes',
      'path': '/landing/',
      'dynamic': false,
      'title': 'Landing::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/oauth/index.js'),
      'rotation': 'routes',
      'path': '/oauth/',
      'dynamic': false,
      'title': 'Third Party Login::AofL Educator Center',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/password-request/index.js'),
      'rotation': 'routes',
      'path': '/password/request/',
      'dynamic': false,
      'title': 'Password Request::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/reports/index.js'),
      'rotation': 'routes',
      'path': '/reports/',
      'dynamic': false,
      'title': 'Reports::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/password-reset/index.js'),
      'rotation': 'routes',
      'path': '/password/reset/',
      'dynamic': false,
      'title': 'Password Reset::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/resources/index.js'),
      'rotation': 'routes',
      'path': '/resources/',
      'dynamic': false,
      'title': 'Resources::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/rosters/index.js'),
      'rotation': 'routes',
      'path': '/rosters/',
      'dynamic': false,
      'title': 'Rosters::Enterprise Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/session-monitor/index.js'),
      'rotation': 'routes',
      'path': '/session-view/',
      'dynamic': false,
      'title': 'Session Monitor::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/unsubscribe/index.js'),
      'rotation': 'routes',
      'path': '/unsubscribe/',
      'dynamic': false,
      'title': 'Unsubscribe::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/token-login/index.js'),
      'rotation': 'routes',
      'path': '/login/:token/',
      'dynamic': true,
      'title': 'Home::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/admins/my-profile/index.js'),
      'rotation': 'routes',
      'path': '/profile/',
      'dynamic': false,
      'title': 'Administrator Profile::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/admins/search/index.js'),
      'rotation': 'routes',
      'path': '/admins/',
      'dynamic': false,
      'title': 'AdminSearchPage Administrators::AofL Management System',
      'meta': {
        'allowedPermissions': [
          'USER_EDIT'
        ]
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/classes/search/index.js'),
      'rotation': 'routes',
      'path': '/classes/:tab/',
      'dynamic': true,
      'title': 'Classes::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/dashboard/progress/index.js'),
      'rotation': 'routes',
      'path': '/dashboard/progress/',
      'dynamic': false,
      'title': 'Progress::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/licenses/details/index.js'),
      'rotation': 'routes',
      'path': '/licenses/details/:id/',
      'dynamic': true,
      'title': 'Licenses::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/licenses/history/index.js'),
      'rotation': 'routes',
      'path': '/licenses/history/',
      'dynamic': false,
      'title': 'Licenses::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/licenses/search/index.js'),
      'rotation': 'routes',
      'path': '/licenses/',
      'dynamic': false,
      'title': 'Licenses::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/org-group/search/index.js'),
      'rotation': 'routes',
      'path': '/org-group/:level/:tab/',
      'dynamic': true,
      'title': 'Organization::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/dashboard/index.js'),
      'rotation': 'routes',
      'path': '/parent/dashboard/:studentId/',
      'dynamic': true,
      'title': 'Welcome::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/home/index.js'),
      'rotation': 'routes',
      'path': '/parent/',
      'dynamic': false,
      'title': 'Parent::Homepage',
      'meta': {},
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/profile/index.js'),
      'rotation': 'routes',
      'path': '/parent/profile/',
      'dynamic': true,
      'title': 'Parent Profile::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/profile-edit/index.js'),
      'rotation': 'routes',
      'path': '/parent/profile/edit/',
      'dynamic': true,
      'title': 'Parent Profile Edit::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/redeem/index.js'),
      'rotation': 'routes',
      'path': '/parent/redeem/:language/',
      'dynamic': true,
      'title': 'Redeem Code::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/redeem-code/index.js'),
      'rotation': 'routes',
      'path': '/parent/redeem-code/',
      'dynamic': false,
      'title': 'Redeem Code::AofL Management System',
      'meta': {},
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/select-language/index.js'),
      'rotation': 'routes',
      'path': '/parent/redeem/',
      'dynamic': false,
      'title': 'Select Language::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/parent/welcome/index.js'),
      'rotation': 'routes',
      'path': '/parent/welcome/:code/',
      'dynamic': true,
      'title': 'Welcome::AofL Management System',
      'meta': {
        'hideLeftPanel': true,
        'skipAuth': true
      },
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/students/search/index.js'),
      'rotation': 'routes',
      'path': '/students/:tab/',
      'dynamic': true,
      'title': 'Students::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/teachers/create/index.js'),
      'rotation': 'routes',
      'path': '/teachers/create/',
      'dynamic': false,
      'title': 'Create Teacher::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/teachers/search/index.js'),
      'rotation': 'routes',
      'path': '/teachers/:tab/',
      'dynamic': true,
      'title': 'Teachers::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/upload-roster/archive/index.js'),
      'rotation': 'routes',
      'path': '/rosters/archive/',
      'dynamic': false,
      'title': 'Rosters::Enterprise Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/upload-roster/license/index.js'),
      'rotation': 'routes',
      'path': '/rosters/license/',
      'dynamic': false,
      'title': 'Rosters::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/upload-roster/upload/index.js'),
      'rotation': 'routes',
      'path': '/rosters/upload/:rosterType/',
      'dynamic': true,
      'title': 'Rosters::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    },
    {
      'resolve': () => import('./../../routes/upload-roster/validate/index.js'),
      'rotation': 'routes',
      'path': '/rosters/validate/',
      'dynamic': false,
      'title': 'Rosters::AofL Management System',
      'locale': 'en-US',
      'template': 'main'
    }
  ]
};